import BaseModelAPI from '../BaseModelAPI';

export default class ReportPoSales extends BaseModelAPI {
	static entity = 'newreport1997';
	static entityName = 'reportposales';

	constructor() {

		/*APP_MODEL_DEFINITION*/
		this.filterCustomer = '';
		this.filterDestination = '';
		this.filterPartNo = '';
		this.filterPoNumber = '';
		this.filterDiDeliveryDate = '';
		this.filterStatusDelivery = '';
		this.tempId = 0;
		this.customerName = '';
		this.destinationName = '';
		this.partNumber = '';
		this.partName = '';
		this.poNoCustomer = '';
		this.qtyDelivery = 0;
		this.qtyActualSupply = 0;
		this.balance = 0;
		this.priceProduct = 0;
		this.amount = 0;
		this.statusDelivery = '';
		this.isFromUpload = false;
		this.isSavedToBackend = true;
		this.uploadValidationMessage = '';
		this.uploadValidationStatus = '';
		/*END_APP_MODEL_DEFINITION*/
	}

}